import { render, staticRenderFns } from "./TrainHeader.vue?vue&type=template&id=45bead72&"
import script from "./TrainHeader.vue?vue&type=script&lang=js&"
export * from "./TrainHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports